"use client";

import { Container } from "@/components/Container";
import CustomerCard from "@/components/CustomerCard";
import type { CustomerCardProps } from "@/components/CustomerCard";
import {
	FadeIn,
	StaggerContainer,
	StaggerItem,
} from "@/components/animations/page-transitions";

const CustomersClient = ({
	customers,
	id,
}: {
	customers: CustomerCardProps[];
	id?: string;
}) => {
	return (
		<FadeIn>
			<section id={id} className="relative py-16">
				<Container>
					<StaggerContainer className="grid grid-cols-1 gap-4 px-8 md:grid-cols-2 lg:grid-cols-3">
						{customers.map((customer) => (
							<StaggerItem key={customer.logo.src}>
								<CustomerCard {...customer} />
							</StaggerItem>
						))}
					</StaggerContainer>
				</Container>
			</section>
		</FadeIn>
	);
};

export default CustomersClient;
